<template>
  <v-card flat>
    <v-card-text>
      <v-card flat class="grey lighten-4" rounded="lg">
        <v-card-text>
          <btn-adicionar-experiencia
            v-if="candidato.pode_atualizar_exp_profis"
          />
          <manut-experiencias-prof />
          <v-data-table
            dense
            class="mt-4"
            hide-default-footer
            :hide-default-header="
              candidato.experienciasprofissionais.length == 0
            "
            no-data-text="Nenhuma experiência informada"
            :items="candidato.experienciasprofissionais"
            :headers="headers"
            :disable-sort="isMobile()"            
          >
            <template v-slot:[`item.admissao`]="{ item }">
              {{ formatarData(item.admissao) }}
            </template>
            <template v-slot:[`item.desligamento`]="{ item }">
              {{ formatarData(item.desligamento) }}
            </template>
            <template v-slot:[`item.desc_cidade`]="{ item }">
              {{ item.desc_cidade }}/{{ item.uf }}
            </template>
            <template
              v-slot:[`item.actions`]="{ item }"
              v-if="candidato.pode_atualizar_exp_profis"
            >
              <btn-editar-experiencia :experiencia="item" />
              <btn-remover-experiencia :experiencia="item" />
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-card-text>
    <v-card-actions v-if="candidato.pode_atualizar_exp_profis">
      <v-row dense v-if="candidato.nivel == 1">
        <v-col xl="6" lg="6" md="6" cols="12">
          <v-btn
            rounded
            block
            class="green lighten-4 font-weight-bold primary--text"
            depressed
            @click="enviarInscricao()"
            :loading="inscrevendo"
            >Confirmar inscrição</v-btn
          >
        </v-col>
        <v-col xl="6" lg="6" md="6" cols="12">
          <btn-voltar-passo />
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <v-btn
            rounded
            block
            class="green lighten-4 font-weight-bold primary--text"
            depressed
            @click="enviarInscricao()"
            :loading="inscrevendo"
            >Atualizar Experiências Profissionais</v-btn
          >
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BtnAdicionarExperiencia from "./botoes/BtnAdicionarExperiencia.vue";
import BtnRemoverExperiencia from "./botoes/BtnRemoverExperiencia.vue";
import ManutExperienciasProf from "./dialogs/ManutExperienciasProf.vue";
import moment from "moment";
import BtnEditarExperiencia from "./botoes/BtnEditarExperiencia.vue";
import BtnVoltarPasso from "./botoes/BtnVoltarPasso.vue";

export default {
  components: {
    BtnAdicionarExperiencia,
    ManutExperienciasProf,
    BtnRemoverExperiencia,
    BtnEditarExperiencia,
    BtnVoltarPasso,
  },
  computed: {
    ...mapState(["candidato"]),
  },
  data: () => ({
    headers: [
      { text: "Empresa", value: "empresa" },
      { text: "Admissão", value: "admissao" },
      { text: "Desligamento", value: "desligamento" },
      { text: "Cargo", value: "cargo" },
      { text: "Cidade", value: "desc_cidade" },
      { text: "", value: "actions", align: "end" },
    ],
    inscrevendo: false,
  }),
  methods: {
    ...mapActions(["confirmarInscricao"]),
    isMobile() {
      return this.$mq == "sm";
    },
    formatarData(value) {
      if (value != "" && value != null)
        return moment(value).format("DD/MM/YYYY");

      return "";
    },
    async enviarInscricao() {
      this.inscrevendo = true;
      var insc = await this.confirmarInscricao();
      if (insc) {
        this.$router.go();
      }
      this.inscrevendo = false;
    },
  },
};
</script>

